import { queryOptions } from '@tanstack/react-query';
import { apiClient } from './client';

/*
 * central object for keys
 *
 * query factory:
 * single source of truth for API endpoints and logic
 *
 * Consistency:
 * If you need to invalidate the cache for "project" everywhere,
 *  you use projectKeys.all
 *
 * Granularity:
 * projectKeys.details(id)
 * ensures that CLOUD_SERVER and MANAGED_SERVER data don't overwrite each other in the cache [1, 2].
 */
const projectsKeys = {
  all: ['projects'],
  debitors: () => [...projectsKeys.all, 'debitors'],
  projects: (debitorUuid) => [...projectsKeys.all, 'projects', debitorUuid],
  items: (project0Uuid) => [...projectsKeys.all, 'items', project0Uuid],
};

//FIXME/OPENISSUES/TODOS: Debitor uuid is no longer required in `/booking/projects?debitorUuid=${debitorUuid}`!
/*
 * TanStack Query v5 pattern.
 * Define the Key, Fetcher, and Settings (like staleTime) in one reusable object.
 * DRY (Don't Repeat Yourself) code:
 * You can use the same projectQueries.detail(id)
 * for prefetching on the server or in a different component without retyping the logic.
 */
export const projectsQueries = {
  debitors: () =>
    queryOptions({
      queryKey: projectsKeys.debitors(),
      queryFn: async () => {
        const { data } = await apiClient.get('/office/debitors');
        return data;
      },
    }),
  projects: (debitorUuid) =>
    queryOptions({
      queryKey: projectsKeys.projects(),
      queryFn: async () => {
        const { data } = await apiClient.get(
          `/booking/projects?debitorUuid=${debitorUuid}`
        );
        return data;
      },
      enabled: !!debitorUuid,
    }),
  items: (project0Uuid) =>
    queryOptions({
      queryKey: projectsKeys.items(),
      queryFn: async () => {
        const { data } = await apiClient.get(
          `/booking/items?projectUuid=${project0Uuid}`,
          {
            headers: {
              'assumed-roles': `hs_booking.projects#${project0Uuid}:ADMIN`,
            },
          }
        );
        return data;
      },
      enabled: !!project0Uuid,
    }),
};

export { projectsKeys };
